export default {
    route: {
        shj: '售货机',
        wdshj: '我的售货机',
        jqxppz: "机器小票配置",
        sy: '首页',
        syspxlpm: '商品销量排名',
        syzfqq: '支付历史详情',
        syjqpm: '机器销量排名',
        ztcx: '状态查询',
        jqbj: '机器报警',
        mbgl: '模板管理',
        bywx: '保养维修',
        zdfx: '诊断分析',
        dwgl: '点位管理',
        llk: '流量卡',
        jygl: '交易管理',
        jyhz: '交易汇总',
        sh: '退款管理',
        c: '退款管理',
        tkgl: '退款管理',
        ddgl: '订单管理',
        hgsh: '线下取货',
        jqjytj: '机器交易统计',
        jqjymx: '机器交易明细',
        bbdc: '报表导出',
        gk: '概括',
        yxch: '营销策划',
        zkgl: '折扣管理',
        xlspkcpd: '线路商品库存盘点',
        jqspkcpd: '机器商品库存盘点',
        jqhdkcpd: '机器货道库存盘点',
        jqqhbjsz: '机器缺货报警设置',
        bhjl: "补货记录",
        jxcgl: '进销存管理',
        hgxq: '开心购',
        wdgys: '我的供应商',
        gysspsz: '供应商商品设置',
        zfjstj: '支付结算统计',
        spgl: '商品管理',
        ccgl: '仓储管理',
        cgjh: '采购计划',
        cgd: '采购单',
        rkdj: '入库登记',
        cfgl: '财富管理',
        txgl: '提现管理',
        sksz: '收款设置',
        jyjsmx: '交易结算明细',
        sfk: '收付款',
        chd: '出货单',
        bs: '报损/回库',
        bhd: '补货单',
        gggl: '广告管理',
        hygl: '会员管理',
        sqbk: '申请办卡',
        cwgl: '财务管理',
        shgl: '商户管理',
        tdjqsq: '团队机器授权',
        qhmgl: '取货码管理',
        xtgl: '系统管理',
        shzffwcssz: '服务商参数设置',
        zffwgl: '支付服务管理',
        zshcssz: '商户账户设置',
        zfsz: '支付设置',
        cwjs: '财务结算',
        jysj: "交易结算",
        wdsh: "我的商户",
        shjqsq: "商户机器授权",
        kfdh: "客服电话",
        shspgl: "商户商品管理",
        qxgl: '权限管理',
        dagl: '档案管理',
        yhgl: '用户管理',
        zzgl: '组织管理',
        zygl: '资源管理',
        gngl: '功能管理',
        cdgl: '菜单管理',
        cqxgl: '权限管理',
        jsgl: '角色管理',
        xzyh: '新增用户',
        bjyh: '编辑用户',
        gljs: '管理角色',
        bjptzy: '编辑普通资源',
        xzptzy: '新增普通资源',
        jszyqx: '角色资源权限',
        bjjs: '编辑角色',
        xzjs: '新增角色',
        shjMbadd: "模板添加",
        shjMbset: '模板修改',
        setpwd: '修改密码',
        rjs: '日结算',
        spgl: '商品管理',
        kfdh: "客服电话",
        tjfx: '统计分析',
        wdsp: '我的商品',
        zksp: '我的药品',
        ypfl: '药品分类',
        bqbkfl: '病情病况分类',
        wdtd: '我的团队',
        rzgl: '日志管理',
        sjzd: '数据字典管理',
        shsjzd: '商户数据字典管理',
        yxfagl: '营销方案设置',
        yxjhgl: '方案上下架管理',
        yhqgl: '优惠券管理',
        yhmgl: '优惠码管理',
        wdys: '我的药师',
        spjytj: '商品交易统计',
        wdhy: '我的会员',
        wdhyk: '我的会员卡',
        czmx: '充值明细',
        yhsz: '优惠设置',
        ypgl: '药品管理',
        yplb: '药品列表',
        ypqx: '药品期效',
        yppc: '药品批次',
        ypyh: "药品养护",
        wtddgl: '问题交易台账',
        yhmmx: '优惠码明细',
        yxrb: '营销日报',
        sz: '设置',
        // exportZip: 'Export Zip',
        theme: '换肤',
        // clipboardDemo: 'Clipboard',
        i18n: '国际化',
        jyfx: '经营分析',
        mddh: '门店兑换',
        mddhjs: '门店兑换结算',
        spk: '商品库',
        sck: '素材库',
        csgl: '场所管理',
        shjsp: '售货机商品',
        glwdtd: '我的团队',
        glwdsh: '我的商户',
        gltdjqsq: '团队机器授权',
        glshjqsq: '商户机器授权',
        glddgl: '订单管理',
        gltkgl: '退款管理',
        glxxqh: '线下取货',
        glzjtj: '中奖统计',
        glshj: '售货机',
        glwddw: '我的点位',
        glwdshj: '我的售货机',
        gljqzt: '机器状态',
        gljygl: '交易管理',
        glcfgl: '财富管理',
        gltxgl: '提现管理',
        glsksz: '收款设置',
        gljyjsmx: '交易结算明细',
        gmsptj: '购买商品统计',
        spchjl: '商品出货记录',
        jqsptj: '机器商品统计',
        hgjltj: '回购记录统计',
        spfl: '商品分类',
    },
    navbar: {
        logOut: '退出登录',
        dashboard: '首页',
        github: '项目地址',
        setting: '重置密码',
        screenfull: '全屏',
        theme: '换肤',
        logu: '微超',
        logd: '云平台',
        lang: '中文'
    },
    login: {
        title: '微超云平台',
        logIn: '登录',
        username: '默认账号',
        password: '默认密码',
        any: '随便填',
        thirdparty: '第三方登录',
        thirdpartyTips: '本地不能模拟，请结合自己业务进行模拟！！！'
    },
    documentation: {
        documentation: '文档',
        github: 'Github 地址'
    },
    permission: {
        roles: '你的权限',
        switchRoles: '切换权限'
    },
    components: {
        documentation: '文档',
        tinymceTips: '富文本是管理后台一个核心的功能，但同时又是一个有很多坑的地方。在选择富文本的过程中我也走了不少的弯路，市面上常见的富文本都基本用过了，最终权衡了一下选择了Tinymce。更详细的富文本比较和介绍见',
        dropzoneTips: '由于我司业务有特殊需求，而且要传七牛 所以没用第三方，选择了自己封装。代码非常的简单，具体代码你可以在这里看到 @/components/Dropzone',
        stickyTips: '当页面滚动到预设的位置会吸附在顶部',
        backToTopTips1: '页面滚动到指定位置会在右下角出现返回顶部按钮',
        backToTopTips2: '可自定义按钮的样式、show/hide、出现的高度、返回的位置 如需文字提示，可在外部使用Element的el-tooltip元素',
        imageUploadTips: '由于我在使用时它只有vue@1版本，而且和mockjs不兼容，所以自己改造了一下，如果大家要使用的话，优先还是使用官方版本。'
    },
    table: {
        dynamicTips1: '固定表头, 按照表头顺序排序',
        dynamicTips2: '不固定表头, 按照点击顺序排序',
        dragTips1: '默认顺序',
        dragTips2: '拖拽后顺序',
        title: '标题',
        importance: '重要性',
        type: '类型',
        remark: '点评',
        search: '搜索',
        add: '添加',
        export: '导出',
        reviewer: '审核人',
        id: '序号',
        date: '时间',
        author: '作者',
        readings: '阅读数',
        status: '状态',
        actions: '操作',
        edit: '编辑',
        publish: '发布',
        draft: '草稿',
        delete: '删除',
        cancel: '取 消',
        confirm: '确 定'
    },
    errorLog: {
        tips: '请点击右上角bug小图标',
        description: '现在的管理后台基本都是spa的形式了，它增强了用户体验，但同时也会增加页面出问题的可能性，可能一个小小的疏忽就导致整个页面的死锁。好在 Vue 官网提供了一个方法来捕获处理异常，你可以在其中进行错误处理或者异常上报。',
        documentation: '文档介绍'
    },
    excel: {
        export: '导出',
        selectedExport: '导出已选择项',
        placeholder: '请输入文件名(默认excel-list)'
    },
    zip: {
        export: '导出',
        placeholder: '请输入文件名(默认file)'
    },
    theme: {
        change: '换肤',
        documentation: '换肤文档',
        tips: 'Tips: 它区别于 navbar 上的 theme-pick, 是两种不同的换肤方法，各自有不同的应用场景，具体请参考文档。'
    },
    "ddgl": {
        "shbh": "商户编号",
        "jqmc": "机器名称",
        "zfzh": "付款人",
        "zffs": "支付方式",
        "chzt": "出货状态",
        "query": "查询",
        "dds": "交易中",
        "ddcss": "异常单",
        "ddlss": "已完成",
        "zjs": "开心购中奖",
        "wzjs": "开心购未中奖",
        "wxdd": "无效订单",
        "qts": "收付款",
        "index": "序号",
        "jqbh": "机器编号",
        "shxx": "商户名称",
        "shmc": "商户名称",
        "dsfjybh": "交易单号",
        "spzj": "订单总价",
        "yhje": "优惠金额",
        "zfje": "付款金额",
        "cjje": "抽奖金额",
        "spsl": "商品数量",
        "showzfzt": "支付状态",
        "showchzt": "出货状态",
        "cjcs": "抽奖次数",
        "zjzt": "中奖结果",
        "ywlx": "业务类型",
        "ddzt": "订单状态",
        "sc": "操作",
        "ddqx": "订单详情",
        "jqqx": "机器详情",
        "qx": "取消",
        "md": "门店",
        "shj": "售货机",
        "jqlb": "机器类别",
        "jqlx": "机器类型",
        "rjbb": "软件版本",
        "ddbh": "订单编号",
        "cjsj": "创建时间",
        "jssj": "结束时间",
        "jlsj": "建立时间",
        "chxq": "出货详情",
        "zfzt": "支付状态",
        "tkjl": "退款记录",
        "zfsj": "支付时间",
        "dsfshdh": "商户单号",
        "hy": "会员",
        "pjdj": "等级",
        "sfk": "收付款",
        "pjxq": "评价",
        "kh": "该客户什么都没有留下",
        "sp": "商品",
        "hdbh": "货道编号",
        "spbh": "商品编号",
        "spmc": "商品名称",
        "bspdj": "商品单价",
        "bspsj": "商品售价",
        "byhje": "优惠金额",
        "chsj": "出货时间",
        "tkje": "退款金额",
        "tksj": "退款时间",
        "tkzt": "退款状态",
        "tkyy": "退款原因",
        "qd": "确定",
        "tksh": "退款审核",
        "ksrq": "开始日期",
        "jsrq": "结束日期",
        "accountname": "登录账号",
        "gsmc": "公司名称: ",
        "lxr": "联 系 人：",
        "lxdh": "联系电话：",
        "shdz": "商户地址：",
        "kfdh": "客服电话：",
        "lmbm": "类目编码：",
        "bqbm": "标签编码：",
        "shlx": "商户类型：",
        "remark": "备注",
        "swrjbb": "上位App版本",
        "swyjbb": "安卓系统版本",
        "xwrjbb": "下位软件版本",
        "xwyjbb": "下位硬件版本",
        "ddcjsj": "订单创建时间",
        "jqchls": "机器出货历史 ",
        "help": "帮助 ",
        "xq": "详情",
        "cfbm": "处方编码",
        "chsm": "出货说明",
        "ddbz": "如已线下退款请手动标记",
    },
    "tkgl": {
        "jqtktj": "机器退款统计",
        "ztksl": "总退款数",
        "ztkje": "退款总额",
        "ajq": "按机器",
        "ash": "按商户",
        "asjd": "按时间段",
        "add": "按订单",
        "keyword": "商户名称",
        "jqmc": "机器名称",
        "spmc": "商品名称",
        "jydh": "交易单号",
        "jt": "今天",
        "zt": "昨天",
        "jqt": "近七天",
        "qb": "全部",
        "tkz": "退款中",
        "ytk": "已退款",
        "tksb": "退款失败",
        "chsb": "卡货",
        "chcs": "出货超时",
        "qt": "其他",
        "query": "查询",
        "shbh": "商户编号",
        "shmc": "商户名称",
        "jqbh": "机器编号",
        "jqmcs": "机器名称",
        "spbh": "商品编号",
        "spmcs": "商品名称",
        "btkje": "退款金额",
        "showtkfs": "交易方式",
        "zfzh": "付款人",
        "tkry": "操作员",
        "tkzt": "退款状态",
        "tksj": "退款时间",
        "remark": "退款原因",
        "hdkh": "货道卡货",
        "cjsj": "交易时间",
        "cz": "操作",
        "tksh": "退款审核",
        "tkyy": "退款原因",
        "qx": "取 消",
        "qd": "确 定",
        "ddqx": "订单详情",
        "jqqx": "机器详情",
        "zffs": "支付方式",
        "ksrq": "开始日期",
        "jsrq": "结束日期"
    },    
    "dwgl": {
        "Business": "商户名称/编号",
        "PointNumber": "点位编号/名称",
        "query": "查询",
        "Newlyadded": "新增",
        "Pointmap": "点位地图",
        "Pointnumbers": "点位编号",
        "Nameplace": "点位名称",
        "Pointtype": "点位类型",
        "Pointaddress": "点位地址",
        "dwbs": "点位标识",
        "jqsl": "机器数量",
        "dwjd": "点位经度",
        "dwwd": "点位纬度",
        "dwzb": "点位坐标",
        "bz": "备注",
        "cz": "操作",
        "bd": "绑定",
        "jb": "解绑",
        "xg": "修改",
        "sc": "删除",
        "dwdt": "点位地图",
        "dz": "地址",
        "dw": "点位",
        "xlmc": "线路名称",
        "glyid": "管理人员",
        "qymcs": "区域名称",
        "glyids": "管理员编号",
        "glyname": "管理员名称",
        "qybh": "区域编号",
        "dwmc": "点位名称",
        "pcamc": "省/市/区",
        "csmc": "场所名称",
        "dwgl": "点位类型",
        "remark": "备注",
        "qx": "取消",
        "dwwzxz": "点位位置选择",
        "djpj": "点击标记按钮右击地图获取点位位置信息",
        "bc": "保存",
        "jqbh": "机器编号/名称",
        "sfbd": "是否绑定点位",
        "jqmc": "机器名称",
        "xlbh": "线路编号/名称",
        "qymc": "绑定的区域名称",
        "xlbhs": "线路编号",
        "xlmcs": "片区名称",
        "dwfilterText": "输入点位编号或名称",
        "xl": "线路",
        "xlfilterText": "输入线路编号或名称",
        "qyBh": "区域BH/名称",
        "xzqy": "新增区域",
        "cx": "查询",
        "xz": "新增",
        "dwsl": "点位数量",
        "glyxx": "管理员编号/名称",
        "xzgly": "请选择管理人员",
        "qxz": "请选择",
        "tjxl": "添加线路",
        "xgxl": "修改线路",
        "tjqy": "添加区域",
        "xgqy": "修改区域",
        "bddw": "绑定点位",
        "jbdw": "解绑点位",
        "ybd": "已绑定",
        "wbd": "未绑定",
        "delxl": "是否删除该条线路信息, 是否继续?",
        "zjdw": "增加点位",
        "pq": "片区",
        "pqbh": "片区编号",
        "pqmc": "片区名称",
        "tjpq": "添加片区",
        "pqgl": "片区名称",
        "xgpq": "修改片区"
    },
    "button": {
        "zj": "增加",
        "tj": "添加",
        "cz": "操作",
        "zjdw": "增加点位",
        "xg": "修改",
        "xgdw": "修改点位",
        "bd": "绑定",
        "bdjq": "绑定机器",
        "jb": "解绑",
        "jbjq": "解绑机器",
        "bjwz": "标记位置",
        "qxbj": "取消标记",
        "dr": "导入",
        "dc": "导出",
        "scmb": "上传模板",
        "copy": "复制",
        "bc": "保存",
        "qx": "取消",
        "qrxx": "确认信息",
        "qd": "确 定",
        "qb": "全部",
        "xzwj": "下载文件",
        "help": "查看帮助说明",
        "sm": "说明",
        "cx": "查询",
        "tksm": "退款说明",
        "ksrq": "开始日期",
        "jsrq": "结束日期",
        "sc": "上传",
        "xz": "新增",
        "del": "删除"
    },
    "jqbj": {
        "shmc": "商户名称/编号",
        "jqlx": "机器类型",
        "jqbhmc": "机器编号/名称",
        "jqwc": "机器名称/商户名称/位置/商户编号",
        "query": "查询",
        "index": "序号",
        "jqbh": "机器编号",
        "jqmc": "机器名称",
        "shbh": "商户编号",
        "shmc2": "商户名称",
        "swrjbb": "上位机版本",
        "xwrjbb": "下位机版本",
        "hdbh": "货道编号",
        "yczt": "异常状态",
        "xq": "详情",
        "qckhhd": "清除卡货货道",
        "qcgzhd": "清除故障货道",
        "tip1": "是否确定清除卡货货道",
        "tip2": "是否确定清除故障货道"
    },
    "message": {
        "bjwzmsg": "请标记位置后再保存",
        "qxsc": "已取消删除",
        "tip": "提示",
        "success": "成功!",
        "success2": "成功",
        "bnwk": "不能为空!",
        "tksm1": "1.开心购订单",
        "tksm2": "开心购订单不退款",
        "tksm3": "2.普通订单",
        "tksm4": "售货机设置了自动退款的：出货失败或卡货时，系统会立即退款。",
        "tksm5": "异常订单,如售货机收到出货指令后没反应的，系统会在5分钟后退款",
        "tksm6": "  售货机未设置自动退款的：需手动退款",
        "sm1": "支付宝收款:每笔交易实时到账,实时扣手续费,每笔交易最低手续费0.01元",
        "sm2": "微信(通联)收款:每日凌晨后清算,按当日总交易额计算手续费,不足0.01元的,不收取手续费",
        "sm3": "结算差额为负数的是多结算的",
        "xzcg": "新增成功",
        "xgcg": "修改成功",
        "sccg": "删除成功",
        "xzsb": "新增失败",
        "xgsb": "修改失败",
        "scsb": "删除失败",
        "bhts": "说明:该功能暂时只针对面对面的机型的商户",
    },
    "sksz": {
    	"qxz": "请选择",
    	"cx": "查询",
    	"tj": "添加",
    	"shbh": "商户编号",
    	"shmc": "商户名称",
    	"zffws": "支付服务商",
    	"zffw": "支付服务",
    	"jqbh": "机器编号",
    	"skzh": "收款账号(银行卡号)",
    	"yhmc": "银行名称",
    	"sfjh": "是否激活",
    	"ybz": "预备中,去激活",
    	"yty": "已停用",
    	"yjh": "已激活",
    	"cz": "操作",
    	"xg": "修改",
    	"jlsj": "建立时间",
    	"xgsj": "修改时间",
    	"zfbt": "支付标题",
    	"skdw": "收款单位(个人姓名)",
    	"tjsm": "添加成功后，点击【修改】扫码支付后获取收款账号(或绑定银行卡)，然后再激活",
    	"tjsm2": "添加成功后,然后再激活",
    	"qx": "取消",
    	"lrzl": "请在【银行名称】录入如下格式的资料",
    	"khzhmc": "开户支行详细名称/银行代码/省/市/开户支行行号/银行卡00或者存折01/个人用0 或者 对公用1/",
    	"r": "如",
    	"khzhmc2": "中国银行股份有限公司长沙市岳麓支行/0104/湖南/长沙/104551004522/01/1/",
    	"khzhhh": "开户支行行号：可以咨询开户行 或登录: http://www.5cm.cn/bank/  查询",
    	"yhdm": "银 行 代 码    ：可以咨询开户行 或登录: http://www.xyzfpt.com/doc/  查询",
    	"zfhdj": "支付后,请点击获取",
    	"bc": "保存",
    	"zhjhh": "账户激活后正式使用，无法修改",
    	"yzm": "验证码",
    	"jh": "激活",
    	"smhqskzh": "扫码获取收款帐号",
    	"sm": "说明",
    	"my": "密钥",
    	"ylzh": "银联账号",
    	"tyshh": "特约商户号",
    	"tip2": "显示全部",
    	"tip3": "所有机器使用同一收款时请不要填写",
    	"start": "启用",
    	"zfbsqm": "支付宝授权码",
    },
}



// WEBPACK FOOTER //
// ./src/lang/zh.js